// resolveCurrentEnvironment — which row in the environment list is the one
// actually loaded right now.
//
// Two facts drive the rule, and both cost a bug:
//
// 1. MATCH BY assetId FIRST. A format-pinned load (ENG-1070's `?format=` /
//    node `urlOverride`, e.g. a PLY variant) sets splatUrl to a per-format
//    file that is never equal to the row's own `.url` — the org list
//    deliberately omits per-format URLs (it can't tell which artifacts exist
//    without a per-row fetch). URL equality alone therefore can never
//    recognize that load as "this environment", and the whole
//    Save-for-everyone footer stayed hidden while a real environment was
//    active. URL match remains the fallback for the gap before assetId
//    resolves (a fresh `?splat=` deep link, which has no row in hand).
//
// 2. NOTHING IS LOADED WITHOUT A splatUrl. `assetId` is written ephemerally
//    and is NOT cleared everywhere splatUrl is (characterState.js clears the
//    URL on a character switch; CustomAssetManager clears it on an env
//    delete), and `listEnvironments` ignores its slug — every environment is
//    org-wide, so a stale id from the previous character is GUARANTEED to
//    match a row in the next one's list. Without this guard the panel then
//    reports that environment as current with no splat loaded, which
//    re-enables both "Save for everyone" buttons pointed at a shared org row:
//    a click would overwrite that row's default_pose / default_tune for the
//    whole org. The guard is what makes the id match safe; clearing the id at
//    every site that clears the URL is the other half (see characterState.js).
//
// Pure: no store access, no fetch. The panel passes the live values in.
export function resolveCurrentEnvironment(environments, environment) {
  const env = environment ?? {}
  // No splat loaded → no current environment, whatever a stale id says.
  if (!env.splatUrl) return null
  const list = Array.isArray(environments) ? environments : []
  return list.find(e =>
    (env.assetId ? e?.id === env.assetId : false) || e?.url === env.splatUrl) ?? null
}
